import React from 'react';
import { Link } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const IndustryCTA = () => {
  return (
    <section className="py-12 md:py-16 lg:py-20 bg-gradient-to-br from-primary to-primary/80 relative overflow-hidden">
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-0 left-0 w-96 h-96 bg-white rounded-full blur-3xl"></div>
        <div className="absolute bottom-0 right-0 w-96 h-96 bg-white rounded-full blur-3xl"></div>
      </div>
      
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="text-center">
          <div className="inline-flex items-center space-x-2 bg-white/20 backdrop-blur-sm text-white px-4 py-2 rounded-full text-sm font-medium font-body mb-6">
            <Icon name="Sparkles" size={16} />
            <span>Ready to Transform Your Industry?</span>
          </div>
          
          <h2 className="text-2xl md:text-3xl lg:text-5xl font-bold font-headline text-white mb-6 leading-tight">
            Let's Build Your Industry-Leading Solution
          </h2>
          
          <p className="text-base md:text-lg lg:text-xl text-white/90 font-body mb-8 max-w-3xl mx-auto leading-relaxed">
            Schedule a free consultation to discuss your industry-specific challenges and discover how our expertise can drive measurable transformation for your business.
          </p>
          
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Button
              variant="default"
              size="lg"
              iconName="Calendar"
              iconPosition="left"
              onClick={() => window.location.href = '/contact'}
              className="bg-white text-primary hover:bg-white/90"
            >
              Schedule Free Consultation
            </Button>
            <Link
              to="/services"
              className="inline-flex items-center space-x-2 px-6 py-3 rounded-lg border-2 border-white text-white hover:bg-white/10 transition-all duration-200 text-base font-medium font-body"
            >
              <span>Explore Our Services</span>
              <Icon name="ArrowRight" size={18} />
            </Link>
          </div>
          
          <div className="mt-12 grid grid-cols-1 sm:grid-cols-3 gap-6 max-w-3xl mx-auto">
            <div className="flex items-center justify-center space-x-3 bg-white/10 backdrop-blur-sm px-4 py-3 rounded-lg">
              <Icon name="Clock" size={20} className="text-white" />
              <span className="text-sm font-medium text-white font-body">30-Min Discovery Call</span>
            </div>
            <div className="flex items-center justify-center space-x-3 bg-white/10 backdrop-blur-sm px-4 py-3 rounded-lg">
              <Icon name="FileText" size={20} className="text-white" />
              <span className="text-sm font-medium text-white font-body">Custom Proposal</span>
            </div>
            <div className="flex items-center justify-center space-x-3 bg-white/10 backdrop-blur-sm px-4 py-3 rounded-lg">
              <Icon name="Shield" size={20} className="text-white" />
              <span className="text-sm font-medium text-white font-body">No Obligation</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default IndustryCTA;